import { PageLayout } from '@/shared/components/PageLayout';
import React from 'react';
import { BrokenSubscriptionsFilters } from '../components/BrokenSubscriptionsFilters';
import { BrokenSubscriptionsList } from '../components/BrokenSubscriptionsList';
import { useBrokenSubscriptions } from '../hooks/useBrokenSubscriptions';

const BrokenSubscriptionsPage: React.FC = () => {
  const {
    brokenSubscriptions,
    loading,
    error,
    currentPage,
    perPage,
    lastPage,
    total,
    filters,
    handlePageChange,
    handlePerPageChange,
    handleFiltersChange,
    handleClearFilters,
  } = useBrokenSubscriptions();

  return (
    <PageLayout>
      <BrokenSubscriptionsFilters
        filters={filters}
        onFiltersChange={handleFiltersChange}
        onClearFilters={handleClearFilters}
      />
      <BrokenSubscriptionsList
        subscriptions={brokenSubscriptions}
        loading={loading}
        error={error}
        currentPage={currentPage}
        perPage={perPage}
        lastPage={lastPage}
        total={total}
        onPageChange={handlePageChange}
        onPerPageChange={handlePerPageChange}
      />
    </PageLayout>
  );
};

export { BrokenSubscriptionsPage };
